import { Text } from '../text'

import { SelectProps, SelectSizeEnum, SelectVariantEnum } from './select.type'

import { generateClasses } from './select.constants'

import styles from './select.module.css'

const Select = ({
  className,
  disabled,
  onChange,
  size = SelectSizeEnum.medium,
  variant = SelectVariantEnum.primary,
  value = '',
  iconLeft,
  iconRight,
  placeholder,
  id,
  options,
  error,
  ref,
  onKeyDown,
  allowEmpty = true,
}: SelectProps) => {
  const classes = generateClasses(value === '', size, !!error, variant)
  const selectValue = value !== null ? value : ''

  return (
    <div className={className}>
      <div className={classes}>
        {!iconLeft || <div className={styles['left-icon']}>{iconLeft}</div>}
        <select
          disabled={disabled}
          onChange={(e: React.ChangeEvent<HTMLSelectElement>) => {
            const newValue = e.target.value
            if (!allowEmpty && newValue === '') return
            onChange?.(newValue)
          }}
          value={selectValue}
          id={id}
          ref={ref}
          onKeyDown={onKeyDown}
        >
          {allowEmpty && <option value="">{placeholder}</option>}

          {options.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
        {!iconRight || <div className={styles['right-icon']}>{iconRight}</div>}
      </div>

      {!error || <Text className={styles.error}>{error}</Text>}
    </div>
  )
}

export default Select
